import { render, staticRenderFns } from "./ViewItems.vue?vue&type=template&id=326b20d3&scoped=true"
import script from "./ViewItems.vue?vue&type=script&lang=js"
export * from "./ViewItems.vue?vue&type=script&lang=js"
import style0 from "./ViewItems.vue?vue&type=style&index=0&id=326b20d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326b20d3",
  null
  
)

export default component.exports